import React from 'react';
import { APITypes, MedicalDataTypes, Dynamo } from '../../../../primary-record-types';
import RenderWithProviders from '../RenderWithProviders';
import MaybeFDAInputGate from './MaybeFDAInputGate';
import { withRemountOnFocus } from '../../../HOC/withRemountOnFocus';

export { isEndDateInPast } from './Form';

export type MedicationFormOwnProps = {
    isLoading: boolean;
    startDateTime?: string;
    endDateTime?: string;
    defaultResource?: MedicalDataTypes.PrimaryRecordMedication;
    defaultImages?: Dynamo.ResourceImage[];
    onSubmit: (data: APITypes.medicalDataService.UpdateResourceBody<MedicalDataTypes.PrimaryRecordMedication>) => void;
    /**
     * Lets the screen interject before a save. It resolves with the body to submit - optionally
     * adding fields such as group ids - or null if the user backed out, in which case the form
     * stays dirty so the unsaved-changes guard still applies.
     */
    confirmBeforeSubmit?: (
        data: APITypes.medicalDataService.UpdateResourceBody<MedicalDataTypes.PrimaryRecordMedication>,
    ) => Promise<APITypes.medicalDataService.UpdateResourceBody<MedicalDataTypes.PrimaryRecordMedication> | null>;
    isDisabled: boolean;
    profileId: string;
    resourceId?: string;
    onCancel: () => void;
};

export type MedicationFormProps = MedicationFormOwnProps;

const MedicationForm: React.FC<MedicationFormProps> = (props) => {
    return (
        <RenderWithProviders
            medicalProfileId={props.profileId}
            render={(providers) => <MaybeFDAInputGate {...props} providers={providers} />}
        />
    );
};

export default React.memo(withRemountOnFocus(MedicationForm));
